import React, { useEffect, useState, useRef } from "react";

import { useRouter } from "next/router";

import { TabProps } from "../Tabs";

export const useTabsProps = (tabLabels: TabProps[], initialTabNumber = 0) => {
  const [tabs, setTabs] = useState<TabProps[]>([]);
  const [value, setValue] = useState<number>(initialTabNumber);

  const router = useRouter();
  const currentPath = router.asPath;

  const tabLabelsRef = useRef<TabProps[]>(tabLabels);
  tabLabelsRef.current = tabLabels;

  const memoizedValue = React.useMemo(() => value, [value]);

  const onChange = (
    _event: React.SyntheticEvent<Element, Event>,
    value: number,
  ) => {
    setValue(value);
  };

  useEffect(() => {
    const tabsArr = tabLabelsRef.current.map(
      ({ label, selectedOnRoute, isDisabled, tooltipLabel, ...rest }, i) => {
        if (selectedOnRoute === currentPath) {
          setValue(i);
        }
        return { label, isDisabled, tooltipLabel, ...rest };
      },
    );

    setTabs(tabsArr);
  }, [currentPath]);

  return { tabs, value: memoizedValue, onChange };
};
